import { estados } from './Estados.js';

/*
 * This class simply helps us coordinate the transitions
 * between states. We've hardcoded the state "tree" in 
 * the constructor. This class makes sure that any
 * transition between states requested by the app
 * are valid.
 */
export class MaquinaDeEstados {
  
    constructor() {
        this.transitions = {
            [estados.INICIADO] : [estados.FASE_1],
            [estados.FASE_1] : [estados.FASE_2, estados.ACEPTADO , estados.RECHAZADO],
            [estados.FASE_2] : [estados.FASE_3, estados.RECHAZADO],
            [estados.FASE_3] : [estados.ACEPTADO, estados.RECHAZADO],
            [estados.ACEPTADO] : [estados.FASE_1, estados.FINISH],
            [estados.RECHAZADO] : [estados.INICIADO, estados.FINISH], // FYI the FINISH state is not used
        };
    }

  _reverseObject(obj) {
    let reversed = {};
    for(const key in obj) {
      if(obj.hasOwnProperty(key)) {
        obj[key].forEach((i) => {
          if(reversed[i] === undefined) {
            reversed[i] = [key];
          } else {
            reversed[i].push(key);
          }
        });
      }
    }
    return reversed;
  }

  _checkState(available, desired) {
    if (available.includes(desired)) {
      return desired;
    } else {
      console.log(`Estado solicitado: ${desired} no está disponible.`);
      console.log(`available : ${available} `);
      throw new Error(`Estado solicitado: ${desired} no está disponible.`);
    }
  }

  transitionTo(current, desired) {
    let available = this.transitions[current].concat();
    return this._checkState(available, desired);
  }

  transitionFrom(current, desired) {
    let reversed = this._reverseObject(this.transitions);
    let available = reversed[current].concat();
    return this._checkState(available, desired);
  }
}